export const ANTICHEAT_WEAPON_LABELS: Readonly<Record<string, string>> = {
	weapon_unarmed: 'Безоружный',
	weapon_dagger: 'Кавалерийский кинжал',
	weapon_bat: 'Бейсбольная бита',
	weapon_bottle: 'Бутылка',
	weapon_crowbar: 'Фомка',
	weapon_flashlight: 'Фонарь',
	weapon_golfclub: 'Клюшка для гольфа',
	weapon_hammer: 'Молоток',
	weapon_hatchet: 'Топорик',
	weapon_knuckle: 'Кастет',
	weapon_knife: 'Нож',
	weapon_machete: 'Мачете',
	weapon_switchblade: 'Выкидной нож',
	weapon_nightstick: 'Полицейская дубинка',
	weapon_wrench: 'Разводной ключ',
	weapon_battleaxe: 'Боевой топор',
	weapon_poolcue: 'Кий',
	weapon_stone_hatchet: 'Каменный топор',
	weapon_candycane: 'Карамельная трость',
	weapon_pistol: 'Пистолет',
	weapon_pistol_mk2: 'Пистолет Mk II',
	weapon_combatpistol: 'Боевой пистолет',
	weapon_appistol: 'Бронебойный пистолет',
	weapon_stungun: 'Шокер',
	weapon_pistol50: 'Пистолет .50',
	weapon_snspistol: 'Карманный пистолет',
	weapon_snspistol_mk2: 'Карманный пистолет Mk II',
	weapon_heavypistol: 'Тяжелый пистолет',
	weapon_vintagepistol: 'Винтажный пистолет',
	weapon_flaregun: 'Сигнальный пистолет',
	weapon_marksmanpistol: 'Пистоль',
	weapon_revolver: 'Тяжелый револьвер',
	weapon_revolver_mk2: 'Тяжелый револьвер Mk II',
	weapon_doubleaction: 'Самовзводный револьвер',
	weapon_raypistol: 'Up-n-Atom-изатор',
	weapon_ceramicpistol: 'Керамический пистолет',
	weapon_navyrevolver: 'Флотский револьвер',
	weapon_gadgetpistol: 'Пистолет Перико',
	weapon_stungun_mp: 'Шокер',
	weapon_microsmg: 'Микро-ПП',
	weapon_smg: 'ПП',
	weapon_assaultsmg: 'Штурмовой ПП',
	weapon_combatpdw: 'ПОС',
	weapon_machinepistol: 'Малый ПП',
	weapon_smg_mk2: 'ПП Mk II',
	weapon_minismg: 'Мини-ПП',
	weapon_raycarbine: 'Лазерный автомат',
	weapon_tecpistol: 'Тактический ПП',
	weapon_pp1901vityaz: 'ПП-19-01 «Витязь»',
	weapon_assaultrifle: 'Штурмовая винтовка',
	weapon_carbinerifle: 'Автоматическая винтовка',
	weapon_advancedrifle: 'Улучшенная винтовка',
	weapon_specialcarbine: 'Особый карабин',
	weapon_specialcarbine_mk2: 'Особый карабин Mk II',
	weapon_bullpuprifle: 'Винтовка-"буллпап"',
	weapon_bullpuprifle_mk2: 'Винтовка-"буллпап" Mk II',
	weapon_compactrifle: 'Укороченная винтовка',
	weapon_assaultrifle_mk2: 'Штурмовая винтовка Mk II',
	weapon_carbinerifle_mk2: 'Винтовка-автомат Mk II',
	weapon_militaryrifle: 'Военная винтовка',
	weapon_heavyrifle: 'Тяжелая винтовка',
	weapon_tacticalrifle: 'Табельный карабин',
	weapon_battlerifle: 'Боевая винтовка',
	weapon_asval: 'АС «Вал»',
	weapon_mg: 'Пулемет',
	weapon_combatmg: 'Тяжелый пулемет',
	weapon_combatmg_mk2: 'Тяжелый пулемет Mk II',
	weapon_gusenberg: 'ПП Гузенберга',
	weapon_rpk16: 'РПК-16',
	weapon_pumpshotgun: 'Помповый дробовик',
	weapon_pumpshotgun_mk2: 'Помповый дробовик Mk II',
	weapon_sawnoffshotgun: 'Дробовик-обрез',
	weapon_assaultshotgun: 'Штурмовой дробовик',
	weapon_combatshotgun: 'Боевой дробовик',
	weapon_bullpupshotgun: 'Дробовик - "буллпап"',
	weapon_heavyshotgun: 'Тяжелый дробовик',
	weapon_dbshotgun: 'Двуствольный обрез',
	weapon_autoshotgun: 'Автоматический дробовик',
	weapon_sniperrifle: 'Снайперская',
	weapon_heavysniper: 'Тяжелая снайперская',
	weapon_heavysniper_mk2: 'Тяжелая снайперская Mk II',
	weapon_musket: 'Мушкет',
	weapon_marksmanrifle: 'Высокоточная винтовка',
	weapon_marksmanrifle_mk2: 'Высокоточная винтовка Mk II',
	weapon_precisionrifle: 'Прецизионная винтовка',
	weapon_rpg: 'РПГ',
	weapon_grenadelauncher: 'Гранатомет',
	weapon_grenadelauncher_smoke: 'Гранатомет для газа',
	weapon_minigun: 'Миниган',
	weapon_firework: 'Пиротехника',
	weapon_railgun: 'Рельсотрон',
	weapon_hominglauncher: 'Ракетная установка',
	weapon_compactlauncher: 'Укороченный гранатомет',
	weapon_rayminigun: 'Плазмотрон',
	weapon_emplauncher: 'Компактный ЭМИ',
	weapon_railgunxm3: 'Рельсотрон',
	weapon_grenade: 'Граната',
	weapon_bzgas: 'Газ BZ',
	weapon_molotov: 'Коктейль Молотова',
	weapon_stickybomb: 'Бомба-липучка',
	weapon_proxmine: 'Неконтактная мина',
	weapon_snowball: 'Снежок',
	weapon_pipebomb: 'Самодельная бомба',
	weapon_ball: 'Мяч',
	weapon_smokegrenade: 'Газовая шашка',
	weapon_flare: 'Фальшфейер',
	weapon_acidpackage: 'Пакет с кислотой',
	weapon_petrolcan: 'Канистра',
	weapon_fireextinguisher: 'Огнетушитель',
	weapon_hazardcan: 'Канистра с химикатами',
	weapon_fertilizercan: 'Канистра с удобрениями',
	gadget_parachute: 'Парашют',
};

export const getAnticheatWeaponLabel = (weapon: string): string =>
	ANTICHEAT_WEAPON_LABELS[weapon.toLowerCase()] ?? weapon;
